import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { useAnalytics } from '@carvana/analytics';
import { getMediaQuery } from '@carvana/showroom-theme';
import { ArticleLink } from '../../../styles/article-link';
import { Section, InnerSection } from '../../../styles/section/section';
import { useArticleContext } from '../context';
import { sortArrayBasedonArrayOrder } from '../../../utils/sort-array-based-on-array-order';
import { sanitizeUrl } from '../../../utils/sanitize-url';
import { SendInViewEvent } from '../../../helpers/send-in-view-event';

const SectionWrapper = styled(Section)`
  padding-top: 0;
`;

const RelatedArticlesWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${(props) => getMediaQuery(props.theme.breakpoint.lg)} {
    max-width: 70%;
  }

  ${(props) => getMediaQuery(props.theme.breakpoint.xl)} {
    max-width: 50%;
  }
`;

const RelatedArticleTitle = styled.h3`
  text-transform: uppercase;
  padding-bottom: 20px;
`;

const SeeAllArticlesLink = styled(Link)`
  text-decoration: underline;
  color: ${(props) => props.theme.color.primary.v200};

  &:hover {
    color: ${(props) => props.theme.color.primary.v200};
  }
`;

export const RelatedArticles = () => {
  const { trackEvent } = useAnalytics();
  const { allStrapiArticle, getSupportData, strapiArticle, isLoading } = useArticleContext() || {};
  const articles = allStrapiArticle?.edges;
  const sortedArticleIds = getSupportData?.articles;

  const tempSortedArticles = sortArrayBasedonArrayOrder(
    articles,
    sortedArticleIds,
    (x) => x.node.strapiId
  );
  const sortedArticles =
    tempSortedArticles && tempSortedArticles?.length > 0
      ? tempSortedArticles?.slice(0, 6)
      : articles.filter((x) => x.node.topic.id === strapiArticle.topic?.id)?.slice(0, 6);

  const [ref] = SendInViewEvent({
    isLoading,
    component_name: 'article_related_articles',
    data: { strapiArticle, sortedArticles, sortedArticleIds }
  });

  return (
    <SectionWrapper primary ref={ref}>
      <InnerSection>
        <RelatedArticlesWrapper>
          <RelatedArticleTitle>Related Articles</RelatedArticleTitle>

          {sortedArticles?.splice(0, 5)?.map((article) => (
            <ArticleLink key={article.node.id} article={article.node} />
          ))}

          <SeeAllArticlesLink
            to={`/${sanitizeUrl(strapiArticle?.topic?.topic_url)}`}
            onClick={() => {
              trackEvent(
                'content_engagement',
                {
                  clickstream: {
                    engagement_type: 'see_all_articles_on_topic_link',
                    link: `/${sanitizeUrl(strapiArticle?.topic?.topic_url)}`,
                    data: strapiArticle
                  }
                },
                ['clickstream']
              );
            }}
          >
            See all articles on this topic
          </SeeAllArticlesLink>
        </RelatedArticlesWrapper>
      </InnerSection>
    </SectionWrapper>
  );
};
